import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from '@shared/components/forms/base-form.component';

@Component({
  selector: 'app-press-form',
  templateUrl: './press-form.component.html',
  styleUrls: ['./press-form.component.scss'],
})
export class PressFormComponent extends BaseFormComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    this.addRecaptchaScript('press-email-send');
  }
}
